import {
  Component,
  HostListener,
  OnDestroy,
  OnInit,
  TemplateRef,
  ViewContainerRef,
} from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import {
  getFormattedDate,
  isLargeScreen,
  updateCustomTableHeaders,
} from '../../../../../global.variable';
import { AppService } from '../../../../app.service';
import { ModalDialogueService } from '../../../../shared/components/modal-dialogue/modal-dialogue.service';
import { LoadingSpinnerService } from '../../../../shared/services/loading-spinner.service';
import { ToasterService } from '../../../../shared/services/toaster.service';
import { RosterShiftsService } from '../../roster-shifts/roster-shifts.service';

@Component({
  selector: 'gtapp-conditional-roster-jobs',
  templateUrl: './conditional-roster-jobs.component.html',
  styleUrl: './conditional-roster-jobs.component.scss',
  standalone: false,
})
export class ConditionalRosterJobsComponent implements OnInit, OnDestroy {
  largeView: Boolean = isLargeScreen;
  jobListData: any = [];

  // totalCondtionalRosterShifts: number = 0;
  previousCondtionalRosterShifts: number = 0;
  rowsCondtionalRosterShifts: number = 10;
  pageNumCondtionalRosterShifts: number = 1;
  totalPagesCondtionalRosterShifts: number = 0;
  allotedUserCount: number = 0;
  sortKeyCondtionalRosterShifts: any;
  searchParamsCondtionalRosterShifts: any;
  otherParamsCondtionalRosterShifts: any = { apiFiltering: true };

  rosterJobCondition:
    'unAssignedJobs' | 'staleShifts' | 'requireAcceptance' | 'pendingShifts' =
    'unAssignedJobs';
  jobDetailsTableView: any = this.getTableDetailList();
  // shift that require acceptance/decline params
  rosterShiftRows: number = 20;
  rosterShiftPrevious: number = 0;
  rosterShiftPageNum: number = 1;
  rosterShiftTotalPages: number = 0;
  rosterShiftTotalCount: number = 0;

  alreadyLoading: boolean = false;

  declineReason: string = '';

  subscriberUserId =
    this.appService.getUserData()?.subscriber?.subscriber_user_id;
  selectedShiftIds: any = [];

  selectedDate = getFormattedDate(this.getCurrentMonday());
  currentMonday = this.getCurrentMonday();
  selectedWeekEnd = getFormattedDate();

  showAllData: boolean = this.rosterJobCondition === 'unAssignedJobs';

  constructor(
    private rsService: RosterShiftsService,
    private toasterService: ToasterService,
    private spinnerService: LoadingSpinnerService,
    private route: ActivatedRoute,
    private router: Router,
    private dialogService: ModalDialogueService,
    private appService: AppService,
    private viewContainerRef: ViewContainerRef,
  ) {
    if (
      this.route.snapshot.fragment &&
      [
        'unAssignedJobs',
        'staleShifts',
        'requireAcceptance',
        'pendingShifts',
      ].includes(this.route.snapshot.fragment)
    )
      this.rosterJobCondition = this.route.snapshot.fragment as
        | 'unAssignedJobs'
        | 'staleShifts'
        | 'requireAcceptance'
        | 'pendingShifts';
  }
  ngOnDestroy(): void {}
  ngOnInit(): void {
    this.showAllData = this.rosterJobCondition === 'unAssignedJobs';
    if (this.rosterJobCondition == 'requireAcceptance') {
      this.getJobsRequiringAcceptance();
    } else {
      let selectedFilters: any = sessionStorage.getItem(
        btoa('conditionalRosterShifts'),
      );

      if (selectedFilters) {
        selectedFilters = JSON.parse(selectedFilters);
        const date = selectedFilters?.selectedDate
          ? new Date(selectedFilters?.selectedDate)
          : new Date();
        this.selectedDate = getFormattedDate(date);
        this.showAllData =
          selectedFilters?.showAllData ||
          this.rosterJobCondition === 'unAssignedJobs';
        this.previousCondtionalRosterShifts =
          selectedFilters?.previousCondtionalRosterShifts || 0;
        this.pageNumCondtionalRosterShifts =
          selectedFilters?.pageNumCondtionalRosterShifts || 1;
        this.rowsCondtionalRosterShifts =
          selectedFilters?.rowsCondtionalRosterShifts || 10;
        this.searchParamsCondtionalRosterShifts =
          selectedFilters?.searchParamsCondtionalRosterShifts || {};
      }
      this.jobDetailsTableView = this.getTableDetailList();
      if (!this.selectedDate) {
        this.getMonday();
      }
      this.getWeekEndDate();
      this.getConditionalShifts();
    }
  }
  getWeekEndDate() {
    const weekEnd = new Date(this.selectedDate);
    weekEnd.setDate(weekEnd.getDate() + 6);

    this.selectedWeekEnd = getFormattedDate(weekEnd);
  }
  getMonday(date: Date = new Date()) {
    const monday = new Date(date);
    const day = monday.getDay(); // 0 = Sun

    const diff = day === 0 ? -6 : 1 - day;
    monday.setDate(monday.getDate() + diff);

    this.selectedDate = getFormattedDate(monday);
  }
  getCurrentMonday() {
    const monday = new Date();
    const day = monday.getDay(); // 0 = Sun

    const diff = day === 0 ? -6 : 1 - day;
    monday.setDate(monday.getDate() + diff);

    return getFormattedDate(monday);
  }
  changeWeek(operation: '-' | '+' | 'today') {
    const selectedDay = this.selectedDate
      ? new Date(this.selectedDate)
      : new Date();
    selectedDay.setHours(0, 0, 0, 0);

    const week = 1000 * 60 * 60 * 24 * 7;
    if (operation == '-') {
      this.selectedDate = getFormattedDate(
        new Date(selectedDay.getTime() - week),
      );
    } else if (operation == '+') {
      this.selectedDate = getFormattedDate(
        new Date(selectedDay.getTime() + week),
      );
    } else {
      this.getMonday(new Date(getFormattedDate()));
    }

    this.onSelectedDateChange();
  }
  onSelectedDateChange() {
    if (this.selectedDate) {
      this.getMonday(new Date(this.selectedDate));
    } else {
      setTimeout(() => {
        this.getMonday();
      }, 10);
    }
    this.getWeekEndDate();
    this.previousCondtionalRosterShifts = 0;
    this.pageNumCondtionalRosterShifts = 1;

    this.getConditionalShifts();
    // this.initialDataList['shift'] = [];
  }
  getConditionalShiftCount(reqParams: any) {
    let params: any = { get_count: 1, ...reqParams };
    this.rsService.getCondtionalRosteredJobs(params).then((response: any) => {
      // if (!response?.total_count) this.router.navigate(['/']);
      this.otherParamsCondtionalRosterShifts = {
        ...this.otherParamsCondtionalRosterShifts,
        paginationData: {
          totalRows: response?.total_size,
          previousRows: this.previousCondtionalRosterShifts,
          rows: this.rowsCondtionalRosterShifts,
          pageNum: this.pageNumCondtionalRosterShifts,
          totalPages: this.totalPagesCondtionalRosterShifts,
        },
      };
    });
  }
  onChangePaginationUser(data: any) {
    this.previousCondtionalRosterShifts = data?.paginationData?.previousRows;
    this.pageNumCondtionalRosterShifts = data?.paginationData?.pageNum;

    this.rowsCondtionalRosterShifts = data?.paginationData?.rows;

    this.otherParamsCondtionalRosterShifts.paginationData = {
      ...data?.paginationData,
    };
    this.getConditionalShifts(false);
  }
  sortColumnUser(body: any) {
    this.sortKeyCondtionalRosterShifts = body?.sortList || [];
    this.searchParamsCondtionalRosterShifts = body?.searchParams || {};

    this.getConditionalShifts(false);
  }
  searchColumnUser(event: any) {
    this.searchParamsCondtionalRosterShifts = event?.searchParams || {};
    this.clearValues();
    this.getConditionalShifts();
  }
  clearValues() {
    this.previousCondtionalRosterShifts = 0;
    this.pageNumCondtionalRosterShifts = 1;
  }

  getConditionalShifts(getCount = true) {
    let params: any = {
      rows: 10,
    };
    switch (this.rosterJobCondition) {
      case 'unAssignedJobs':
        params.un_assigned_shifts = 1;
        break;
      case 'staleShifts':
        params.stale_rostered_jobs = 1;
        break;
      case 'pendingShifts':
        params.pending_shifts = 1;
        break;
    }
    if (!this.showAllData) {
      params.date_range = JSON.stringify({
        start: new Date(this.selectedDate),
        end: new Date(this.selectedWeekEnd),
      });
    }
    if (this.previousCondtionalRosterShifts) {
      params['previous'] = this.previousCondtionalRosterShifts;
    }
    if (this.sortKeyCondtionalRosterShifts) {
      params['sort_key'] = this.sortKeyCondtionalRosterShifts;
    }
    if (this.searchParamsCondtionalRosterShifts) {
      params['search_filters'] = JSON.stringify(
        this.searchParamsCondtionalRosterShifts,
      );
    }
    if (getCount) this.getConditionalShiftCount(params);
    this.spinnerService.show('Fetching Data');
    this.rsService.getCondtionalRosteredJobs(params).then((response: any) => {
      if (response?.status === 'success') {
        this.spinnerService.hide();

        this.jobListData = response?.data || [];
        sessionStorage.setItem(
          btoa('conditionalRosterShifts'),
          JSON.stringify({
            selectedDate: this.selectedDate,
            showAllData: this.showAllData,
            previousCondtionalRosterShifts: this.previousCondtionalRosterShifts,
            pageNumCondtionalRosterShifts: this.pageNumCondtionalRosterShifts,
            rowsCondtionalRosterShifts: this.rowsCondtionalRosterShifts,
            searchParamsCondtionalRosterShifts:
              this.searchParamsCondtionalRosterShifts,
          }),
        );
      } else {
        this.spinnerService.hide();
        this.toasterService.setMessage({
          successMessage: '',
          errorMessage: response['message'],
        });
      }
    });
  }
  // updateRoutPath() {
  //   this.router.navigate([], {
  //     queryParams: {
  //       searchParams: this.searchParamsCondtionalRosterShifts,
  //       otherParams: this.otherParamsCondtionalRosterShifts,
  //       userSearchString: this.userSearchString,
  //       selectedTab: this.selectedTab,
  //       accessStatusFilter: this.accessStatusFilter,
  //       userListFilterId: this.userListFilterId,
  //     },
  //     replaceUrl: true,
  //   });
  // }

  openIndividualJob(jobData: any) {
    if (jobData?.job_type_name?.toLowerCase() === 'checkpoint patrol') {
      this.router.navigate([
        '/view-route',
        {
          rKey: String(jobData?.job_id),
        },
      ]);
    } else if (jobData?.job_type_name?.toLowerCase() === 'scheduled patrol') {
      this.router.navigate([
        '/view-runsheet',
        {
          rKey: String(jobData?.job_id),
        },
      ]);
    } else {
      this.router.navigate([`/job-detail/JOBID`], {
        queryParams: { jId: jobData?.job_id },
      });
    }
  }

  getJobsRequiringAcceptance() {
    let params: any = { shifts_requiring_acceptance: 1 };
    if (this.rosterShiftRows) {
      params['rows'] = this.rosterShiftRows;
    }
    if (this.rosterShiftPrevious) {
      params['previous'] = this.rosterShiftPrevious;
    }

    this.spinnerService.show();
    this.rsService.getRosterShifts(params).subscribe((response: any) => {
      if (response?.status === 'success') {
        const responseData = response?.data;

        const existingIds = new Set(
          this.jobListData?.map((item: any) => item?.id),
        );
        const filteredData = responseData?.filter(
          (item: any) => !existingIds?.has(item?.id),
        );
        this.jobListData = [...this.jobListData, ...filteredData];

        this.alreadyLoading = false;
        setTimeout(() => {
          this.checkRemainingSpace();
        }, 1000);

        this.spinnerService.hide();
        this.rosterShiftTotalCount = response['total_size'];
        if (this.rosterShiftTotalCount === 0) this.router.navigate(['/']);
        this.rosterShiftTotalPages = Math.ceil(
          this.rosterShiftTotalCount / this.rosterShiftRows,
        );
        this.spinnerService.hide();
      } else {
        this.spinnerService.hide();
        this.toasterService.setMessage({
          successMessage: '',
          errorMessage: response['message'],
        });
      }
    });
  }
  checkRemainingSpace() {
    const contentContainer = document.querySelector('.roster-shift-content');
    const contentHeight: any = contentContainer?.getBoundingClientRect().bottom;
    const viewportHeight = window.innerHeight; //

    if (contentHeight < viewportHeight && !this.alreadyLoading) {
      // If content height is less than the viewport, load more items
      this.loadMoreData();
    }
  }
  loadMoreData() {
    if (
      this.alreadyLoading ||
      this.jobListData?.length >= this.rosterShiftTotalCount
    )
      return;

    this.alreadyLoading = true;
    this.rosterShiftPrevious = this.rosterShiftPrevious + this.rosterShiftRows;
    this.getJobsRequiringAcceptance();
  }
  @HostListener('window:scroll', ['$event'])
  onScroll(event: any): void {
    if (this.rosterJobCondition != 'requireAcceptance') return;
    const scrollPosition = event.target.documentElement.scrollTop;
    const windowHeight = window.innerHeight;
    const documentHeight = event.target.documentElement.scrollHeight;

    if (
      scrollPosition + windowHeight >= documentHeight - 5 &&
      !this.alreadyLoading
    ) {
      this.loadMoreData();
    }
  }

  openEventDetailPage(job: any) {
    if (job?.job_type_dict?.type_identity === 4) {
      this.router.navigate([
        '/view-route',
        {
          rKey: String(job?.job_uuid),
        },
      ]);
    } else {
      this.router.navigate([`/job-detail/JOBID`], {
        queryParams: { jId: job?.job_uuid },
      });
    }
  }
  openTemplate(template: TemplateRef<any>) {
    this.dialogService.open(template, {}, this.viewContainerRef);
  }
  clearAndFocusTextBox(elementId: string) {
    setTimeout(() => {
      var element = <HTMLInputElement>document.getElementById(elementId);
      element?.focus();
    }, 100);
  }
  onJobActionClick(action: string) {
    const selectedIdLength = this.selectedShiftIds?.length;
    if (!selectedIdLength) return;
    let jobIds: any = [];
    let patrolJobIds: any = [];
    this.jobListData?.forEach((job: any) => {
      if (this.selectedShiftIds?.includes(job?.job_uuid)) {
        if (job?.job_type_dict?.type_identity == 4) {
          patrolJobIds.push(job?.job_uuid);
        } else {
          jobIds.push(job?.job_uuid);
        }
      }
    });

    let requestData: any = { job_ids: jobIds, patrol_ids: patrolJobIds };
    let params: any = {};

    switch (action) {
      case 'accept':
        params.accept = 1;
        this.updateShifts(requestData, params);
        break;
      case 'decline':
        params.decline = 1;
        requestData.decline_reason = this.declineReason;
        this.updateShifts(requestData, params);
        break;
    }
  }
  updateShifts(requestData: any, params: any) {
    this.spinnerService.show();
    this.rsService.updateShifts(requestData, params).then((response: any) => {
      if (response?.status === 'success') {
        this.declineReason = '';
        setTimeout(() => {
          this.jobListData = [];
          this.selectedShiftIds = [];
          this.getJobsRequiringAcceptance();
        }, 1000);
      } else {
        this.spinnerService.hide();
        this.toasterService.setMessage({
          successMessage: '',
          errorMessage: response['message'],
        });
      }
    });
  }
  selectUnSelectJob(job: any) {
    const index = this.selectedShiftIds.findIndex(
      (item: any) => item == job.id,
    );

    if (index > -1) {
      this.selectedShiftIds?.splice(index, 1);
    } else {
      this.selectedShiftIds.push(job?.job_uuid);
    }
  }
  selectAllShifts(event: any) {
    const checked = event.target.checked;

    if (checked) {
      this.selectedShiftIds = this.jobListData?.map(
        (job: any) => job?.job_uuid,
      );
    } else {
      this.selectedShiftIds = [];
    }
  }
  getTableDetailList() {
    const tableDetails = this.largeView
      ? [
          {
            header: 'Date',
            name: 'start_day',
            datetimeObj: true,
            sortKey: 'start_day',
            sortOrder: 'asc',
            dateTimeFormat: 'd MMM y',
          },
          // {
          //   header: 'Type',
          //   name: 'job_type_name',
          //   tableColumnStyle: {
          //     'white-space': 'pre-line',
          //   },
          //   // sortKey: 'job_type_name',
          //   // searchKey: 'job_type_name',
          //   suffixStyle: { 'font-size': '0.75rem' },
          //   suffixNestedValue: (row: any) => {
          //     return row?.service_type_name
          //       ? `\n${row?.service_type_name}`
          //       : '';
          //   },
          // },
          {
            sortKey: 'site_name',
            searchKey: 'site_name',
            header: 'Site/ Patrol',
            // name: 'site_name',
            nestedValue: (row: any) => {
              let shiftName = '';
              if (row?.company_name) shiftName += `${row?.company_name} - `;

              shiftName += row?.site_name;
              return shiftName;
            },

            suffixNestedValue: (row: any) => {
              const suffixList: any = [];

              if (row?.job_type_name)
                suffixList.push(`[${row?.job_type_name}]`);
              if (row?.site_address) suffixList.push(row?.site_address);

              if (suffixList?.length) suffixList.unshift('');

              return suffixList?.join('\n');
            },
            suffixStyle: {
              'font-size': 'small',
              'white-space': 'pre-line',
            },
            tableColumnStyle: {
              'white-space': 'pre-line',
            },
          },
          {
            header: 'Scheduled Time',

            nestedValue: (row: any) => {
              const [startHours, startMinutes] = row?.start_time?.split(':');
              const [endHours, endMinutes] = row?.end_time?.split(':');

              return `${startHours}:${startMinutes} - ${endHours}:${endMinutes}`;
            },

            suffixNestedValue: (row: any) => {
              const shiftDuration =
                row?.job_data?.shift_duration ||
                row?.runsheet_data?.shift_duration ||
                row?.patrol_route_data?.shift_duration;

              return shiftDuration ? `\n[${shiftDuration}]` : null;
            },
            suffixStyle: { 'white-space': 'pre-line' },
          },
          {
            header: 'User',
            name: 'assignee_name',
            sortKey: 'assignee_name',
            hideItem: this.rosterJobCondition == 'unAssignedJobs',
          },

          // {
          //   sortKey: 'company_name',
          //   searchKey: 'company_name',
          //   header: 'Client',
          //   name: 'company_name',
          //   tableColumnStyle: {
          //     'white-space': 'pre-line',
          //   },
          // },
        ]
      : [
          {
            header: 'Date',
            name: 'start_day',
            datetimeObj: true,
            sortKey: 'start_day',
            sortOrder: 'asc',
            dateTimeFormat: 'd MMM y',
            suffixNestedValue: (row: any) => {
              const [startHours, startMinutes] = row?.start_time?.split(':');
              const [endHours, endMinutes] = row?.end_time?.split(':');

              return `\n${startHours}:${startMinutes} - ${endHours}:${endMinutes}`;
            },
            suffixStyle: {
              'font-size': 'smaller',
              'white-space': 'pre-line',
            },
            tableColumnStyle: {
              'white-space': 'pre-line',
              'padding': '6px',
            },
          },
          {
            sortKey: 'site_name',
            searchKey: 'site_name',
            header: 'Site/ Patrol',
            // name: 'site_name',
            nestedValue: (row: any) => {
              let shiftName = '';
              if (row?.company_name) shiftName += `${row?.company_name} - `;

              shiftName += row?.site_name;
              return shiftName;
            },

            suffixNestedValue: (row: any) => {
              const suffixList: any = [];
              if (row?.job_type_name)
                suffixList.push(`[${row?.job_type_name}]`);
              if (row?.site_address) suffixList.push(row?.site_address);

              if (suffixList?.length) suffixList.unshift('');

              return suffixList?.join('\n');
            },
            suffixStyle: {
              'font-size': 'smaller',
              'white-space': 'pre-line',
            },
            tableColumnStyle: {
              'white-space': 'pre-line',
              'padding': '6px',
            },
          },
          {
            header: 'User',
            name: 'assignee_name',
            sortKey: 'assignee_name',
            hideItem: this.rosterJobCondition == 'unAssignedJobs',
            tableColumnStyle: {
              'white-space': 'pre-line',
              'padding': '6px',
            },
          },
        ];
    const filteredTable = tableDetails?.filter((item: any) => !item?.hideItem);
    updateCustomTableHeaders(
      filteredTable,
      this.searchParamsCondtionalRosterShifts,
    );

    return filteredTable;
  }
}
